import { jsx, Fragment } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { SPECIALISATIONS, DEFAULT_SPECIALISATION_COLOR_CODE } from "./constants/constants.js";
import { specialisationPillStyles } from "./pill-specialisations.styles.js";
import "../../../themes/typography/typography.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "color-alpha";
import "../../../themes/external-theme/external-theme.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../constants/colors/palette.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
import "../../../themes/pickers-popper/pickers-popper.js";
const PillSpecialisations = ({ items, t, sx = {} }) => {
  const getSpecColorCode = (spec) => SPECIALISATIONS[spec] ? SPECIALISATIONS[spec].colorCode : DEFAULT_SPECIALISATION_COLOR_CODE;
  const getSpecialisationTranslation = (spec) => SPECIALISATIONS[spec] ? t(SPECIALISATIONS[spec].translationKey) : spec;
  return /* @__PURE__ */ jsx(Fragment, { children: items.map((spec) => /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      sx: {
        ...specialisationPillStyles(getSpecColorCode(spec)),
        ...sx
      },
      children: getSpecialisationTranslation(spec)
    },
    spec
  )) });
};
export {
  PillSpecialisations
};
